import { motion } from "framer-motion";

interface DotsNavProps {
  total: number;
  current: number;
  onSelect: (index: number) => void;
  isChildTheme: boolean;
}

export function DotsNav({ total, current, onSelect, isChildTheme }: DotsNavProps) {
  if (total <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-1.5 py-2 shrink-0 flex-wrap">
      {Array.from({ length: total }, (_, i) => (
        <button
          key={i}
          type="button"
          onClick={() => onSelect(i)}
          className="rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-500"
          aria-label={`Go to slide ${i + 1}`}
          aria-current={i === current ? "true" : undefined}
        >
          <motion.span
            className="block rounded-full"
            animate={{
              width: i === current ? 24 : 10,
              height: 10,
              backgroundColor: i === current ? "var(--lp-purple)" : "var(--lp-nav-bg)",
            }}
            whileHover={isChildTheme ? { scale: 1.2 } : undefined}
            transition={{ type: "spring", stiffness: 400, damping: 25 }}
          />
        </button>
      ))}
    </div>
  );
}
